import AirlineLogoMobile from "./iberojet/airline-logo-mobile.svg";
import AirlineLogo from "./iberojet/airline-logo.svg";
import DoneCard from "./iberojet/done-card.svg";
import ErrorBanner from "./iberojet/icons/banner-error.svg";
import InfoBanner from "./iberojet/icons/banner-info.svg";
import SuccessBannerLight from "./iberojet/icons/banner-success-light.svg";
import SuccessBanner from "./iberojet/icons/banner-success.svg";
import BurgerMenuClose from "./iberojet/icons/burger-menu-close.svg";
import BurgerMenu from "./iberojet/icons/burger-menu.svg";
import CardActionRequired from "./iberojet/icons/card-action-required.svg";
import CardError from "./iberojet/icons/card-error.svg";
import CardHasIssues from "./iberojet/icons/card-has-issues.svg";
import CardInProgress from "./iberojet/icons/card-in-progress.svg";
import CardInfo from "./iberojet/icons/card-info.svg";
import CardResolved from "./iberojet/icons/card-resolved.svg";
import CheckMark from "./iberojet/icons/check-mark.svg";
import CheckboxTick from "./iberojet/icons/checkbox-tick.svg";
import DownChevron from "./iberojet/icons/chevron-down.svg";
import RightChevron from "./iberojet/icons/chevron-right.svg";
import ConsentBannerIcon from "./iberojet/icons/consent-banner-icon.svg";
import DocSampleToggle from "./iberojet/icons/doc-sample-toggle.svg";
import DocSelectorIdSelected from "./iberojet/icons/doc-selector-id-selected.svg";
import DocSelectorId from "./iberojet/icons/doc-selector-id.svg";
import DocSelectorPassportSelected from "./iberojet/icons/doc-selector-passport-selected.svg";
import DocSelectorPassport from "./iberojet/icons/doc-selector-passport.svg";
import DocSelectorPdfSelected from "./iberojet/icons/doc-selector-pdf-selected.svg";
import DocSelectorPdf from "./iberojet/icons/doc-selector-pdf.svg";
import DocSelectorVisaSelected from "./iberojet/icons/doc-selector-visa-selected.svg";
import DocSelectorVisa from "./iberojet/icons/doc-selector-visa.svg";
import EditIcon from "./iberojet/icons/edit.svg";
import NotFound from "./iberojet/icons/not-found.svg";
import PaxError from "./iberojet/icons/pax-error.svg";
import PlaneIcon from "./iberojet/icons/plane.svg";
import ProcessingCheckMark from "./iberojet/icons/processing-check-mark.svg";
import RemoveFileFromList from "./iberojet/icons/remove-file-from-list.svg";
import ScannerError from "./iberojet/icons/scanner-error.svg";
import ScannerOverlayDocBackMrz from "./iberojet/icons/scanner-overlay-doc-back-mrz.svg";
import ScannerOverlayDocBackNoMrz from "./iberojet/icons/scanner-overlay-doc-back-no-mrz.svg";
import ScannerOverlayDocFrontMrz from "./iberojet/icons/scanner-overlay-doc-front-mrz.svg";
import ScannerOverlayDocFrontNoMrz from "./iberojet/icons/scanner-overlay-doc-front-no-mrz.svg";
import ScannerWarning from "./iberojet/icons/scanner-warning.svg";
import SelectChevron from "./iberojet/icons/select-chevron.svg";
import SessionActionRequired from "./iberojet/icons/session-action-required.svg";
import SessionHasIssues from "./iberojet/icons/session-has-issues.svg";
import SessionResolved from "./iberojet/icons/session-resolved.svg";
import SuccessPrimary2 from "./iberojet/icons/success-primary2.svg";
import LoaderAnimation from "./iberojet/loader-animation.gif";
import PassportPreview from "./iberojet/passport-preview.svg";
import { ILocalImages } from "./local-images";
import DocEuro from "./iberojet/icons/document-euro.svg";

export const ClientImages: ILocalImages = {
  passportPreview: PassportPreview,
  loaderAnimation: LoaderAnimation,
  airlineLogo: AirlineLogo,
  airlineLogoMobile: AirlineLogoMobile,
  doneCard: DoneCard,
  icons: {
    scannerOverlayDocFrontNoMrz: ScannerOverlayDocFrontNoMrz,
    scannerOverlayDocFrontMrz: ScannerOverlayDocFrontMrz,
    scannerOverlayDocBackNoMrz: ScannerOverlayDocBackNoMrz,
    scannerOverlayDocBackMrz: ScannerOverlayDocBackMrz,

    docSampleToggle: DocSampleToggle,
    docEuro: DocEuro,
    successPrimary2: SuccessPrimary2,
    scannerError: ScannerError,
    consentBannerIcon: ConsentBannerIcon,
    scannerWarning: ScannerWarning,
    burgerMenu: BurgerMenu,
    burgerMenuClose: BurgerMenuClose,

    docSelectorId: DocSelectorId,
    docSelectorPassport: DocSelectorPassport,
    docSelectorPdf: DocSelectorPdf,
    docSelectorVisa: DocSelectorVisa,

    docSelectorIdSelected: DocSelectorIdSelected,
    docSelectorPassportSelected: DocSelectorPassportSelected,
    docSelectorPdfSelected: DocSelectorPdfSelected,
    docSelectorVisaSelected: DocSelectorVisaSelected,

    removeFileFromList: RemoveFileFromList,
    paxError: PaxError,
    edit: EditIcon,
    notFound: NotFound,
    banner: {
      info: InfoBanner,
      error: ErrorBanner,
      success: SuccessBanner,
      successLight: SuccessBannerLight,
    },
    plane: PlaneIcon,
    chevron: {
      down: DownChevron,
      right: RightChevron,
      select: SelectChevron,
    },
    processingCheckMark: ProcessingCheckMark,
    checkMark: CheckMark,
    checkboxTick: CheckboxTick,
    card: {
      resolved: CardResolved,
      actionRequired: CardActionRequired,
      hasIssues: CardHasIssues,
      inProgress: CardInProgress,
      info: CardInfo,
      error: CardError,
    },
    session: {
      resolved: SessionResolved,
      actionRequired: SessionActionRequired,
      hasIssues: SessionHasIssues,
    },
  },
};

export default ClientImages;
